// extracted by mini-css-extract-plugin
export default {"tableTitle":"Tables_tableTitle__ReATk","checkbox":"Tables_checkbox__b9wP+","blackColor":"Tables_blackColor__hLeFW","searchable__controls":"Tables_searchable__controls__fJ1T6"};